/**
 * @generated SignedSource<<5ffed9d2d8b5e728319b9a1c87810880>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SignersSteps_updateSigningData_Mutation$variables = {
  data: string;
};
export type SignersSteps_updateSigningData_Mutation$data = {
  readonly updateSigningData: {
    readonly sessionInfo: {
      readonly id: string;
      readonly signingData: {
        readonly initials: UnknownJSON | null;
        readonly signatures: UnknownJSON | null;
      } | null;
    };
  } | null;
};
export type SignersSteps_updateSigningData_Mutation = {
  response: SignersSteps_updateSigningData_Mutation$data;
  variables: SignersSteps_updateSigningData_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "data",
            "variableName": "data"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MembersUpdateSigningDataMutationPayload",
    "kind": "LinkedField",
    "name": "updateSigningData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionInfo",
        "kind": "LinkedField",
        "name": "sessionInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberSigningData",
            "kind": "LinkedField",
            "name": "signingData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signatures",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initials",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignersSteps_updateSigningData_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignersSteps_updateSigningData_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd4de76c448a7fbdb2937e0ed6e1c9e2",
    "id": null,
    "metadata": {},
    "name": "SignersSteps_updateSigningData_Mutation",
    "operationKind": "mutation",
    "text": "mutation SignersSteps_updateSigningData_Mutation(\n  $data: String!\n) {\n  updateSigningData(input: {data: $data}) {\n    sessionInfo {\n      id\n      signingData {\n        signatures\n        initials\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f0c229baa10d9fb5fb9c79d76e9533c";

export default node;
